"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NETWORKS = exports.getProviderForWallet = exports.WalletTypes = exports.Mainnet = exports.Baklava = exports.Alfajores = exports.NetworkNames = exports.images = exports.PROVIDERS = exports.SupportedProviders = exports.localStorageKeys = void 0;
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var types_1 = require("./types");
var walletIcons_1 = require("./walletIcons");
exports.localStorageKeys = {
    lastUsedAddress: 'use-contractkit/last-used-address',
    lastUsedNetwork: 'use-contractkit/last-used-network',
    lastUsedWalletType: 'use-contractkit/last-used-wallet',
    lastUsedWalletArguments: 'use-contractkit/last-used-wallet-arguments',
};
var SupportedProviders;
(function (SupportedProviders) {
    SupportedProviders["CeloExtensionWallet"] = "Celo Extension Wallet";
    SupportedProviders["CeloTerminal"] = "Celo Terminal";
    SupportedProviders["CeloWallet"] = "Celo Wallet";
    SupportedProviders["Injected"] = "Injected";
    SupportedProviders["Ledger"] = "Ledger";
    SupportedProviders["MetaMask"] = "MetaMask";
    SupportedProviders["PrivateKey"] = "Private key";
    SupportedProviders["Valora"] = "Valora";
    SupportedProviders["WalletConnect"] = "WalletConnect";
})(SupportedProviders = exports.SupportedProviders || (exports.SupportedProviders = {}));
exports.PROVIDERS = (_a = {},
    _a[SupportedProviders.Valora] = {
        name: 'Valora',
        description: 'Connect to Valora, a mobile payments app that works worldwide',
        icon: walletIcons_1.VALORA,
        canConnect: function () { return true; },
        showInList: function () { return true; },
        listPriority: function () { return 0; },
        installURL: 'https://valoraapp.com/',
    },
    _a[SupportedProviders.CeloExtensionWallet] = {
        name: 'Celo Extension Wallet',
        description: 'Use a wallet from the the Celo chrome extension',
        icon: walletIcons_1.CHROME_EXTENSION_STORE,
        canConnect: function () { return !!window.celo; },
        showInList: function () { return !react_device_detect_1.isMobile; },
        listPriority: function () { return 0; },
        installURL: 'https://chrome.google.com/webstore/detail/celoextensionwallet/kkilomkmpmkbdnfelcpgckmpcaemjcdh/related',
    },
    _a[SupportedProviders.WalletConnect] = {
        name: 'WalletConnect',
        description: 'Scan a QR code to connect your wallet',
        icon: walletIcons_1.WALLETCONNECT,
        canConnect: function () { return true; },
        showInList: function () { return true; },
        listPriority: function () { return 0; },
    },
    _a[SupportedProviders.Ledger] = {
        name: 'Ledger',
        description: 'Sync with your Ledger hardware wallet',
        icon: walletIcons_1.LEDGER,
        canConnect: function () { return true; },
        showInList: function () { return !react_device_detect_1.isMobile; },
        listPriority: function () { return 0; },
    },
    _a[SupportedProviders.CeloWallet] = {
        name: 'Celo Wallet',
        description: 'Connect to Celo Wallet for web or deskop',
        icon: walletIcons_1.CELO,
        canConnect: function () { return true; },
        showInList: function () { return true; },
        listPriority: function () { return 1; },
    },
    _a[SupportedProviders.CeloTerminal] = {
        name: 'Celo Terminal',
        description: 'Connect to the Celo Terminal desktop app',
        // TODO get SVG icon
        icon: 'https://raw.githubusercontent.com/zviadm/celoterminal/main/static/icon.png',
        canConnect: function () { return true; },
        showInList: function () { return !react_device_detect_1.isMobile; },
        listPriority: function () { return 1; },
    },
    _a[SupportedProviders.MetaMask] = {
        name: 'MetaMask',
        description: react_device_detect_1.isMobile ? ('Open this app in your Metamask app') : (react_1.default.createElement(react_1.default.Fragment, null,
            "Use the Metamask browser extension. Celo support is limited.",
            ' ',
            react_1.default.createElement("a", { href: "https://docs.celo.org/getting-started/wallets/using-metamask-with-celo", target: "_blank", onClick: function (e) {
                    e.stopPropagation();
                    e.nativeEvent.stopPropagation();
                }, className: "tw-underline tw-text-gray-900 dark:tw-text-gray-200 tw-font-medium", rel: "noopener noreferrer" }, "Learn more"))),
        icon: walletIcons_1.METAMASK,
        canConnect: function () { var _a; return !!((_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.isMetaMask); },
        showInList: function () { return true; },
        listPriority: function () { return 0; },
        installURL: 'https://metamask.app.link/',
    },
    _a[SupportedProviders.Injected] = {
        name: 'Ethereum Web3',
        description: 'Connect any Ethereum wallet to Celo',
        icon: walletIcons_1.ETHEREUM,
        canConnect: function () { return !!window.ethereum; },
        showInList: function () { return !!window.ethereum && !window.ethereum.isMetaMask; },
        listPriority: function () { return 1; },
    },
    _a[SupportedProviders.PrivateKey] = {
        name: 'Private Key',
        description: 'Enter a plaintext private key to load your account (testing only)',
        icon: walletIcons_1.PRIVATE_KEY,
        canConnect: function () { return true; },
        showInList: function () { return process.env.NODE_ENV !== 'production'; },
        listPriority: function () { return 1; },
    },
    _a);
exports.images = (_b = {},
    _b[SupportedProviders.Valora] = walletIcons_1.VALORA,
    _b[SupportedProviders.MetaMask] = walletIcons_1.METAMASK,
    _b[SupportedProviders.WalletConnect] = walletIcons_1.WALLETCONNECT,
    _b[SupportedProviders.Ledger] = walletIcons_1.LEDGER,
    _b[SupportedProviders.CeloWallet] = walletIcons_1.CELO,
    _b[SupportedProviders.CeloTerminal] = walletIcons_1.CELO,
    _b[SupportedProviders.CeloExtensionWallet] = walletIcons_1.CHROME_EXTENSION_STORE,
    _b[SupportedProviders.PrivateKey] = walletIcons_1.PRIVATE_KEY,
    _b);
var NetworkNames;
(function (NetworkNames) {
    NetworkNames["Alfajores"] = "Alfajores";
    NetworkNames["Baklava"] = "Baklava";
    NetworkNames["Mainnet"] = "Mainnet";
})(NetworkNames = exports.NetworkNames || (exports.NetworkNames = {}));
exports.Alfajores = {
    name: NetworkNames.Alfajores,
    rpcUrl: 'https://alfajores-forno.celo-testnet.org',
    graphQl: 'https://alfajores-blockscout.celo-testnet.org/graphiql',
    explorer: 'https://alfajores-blockscout.celo-testnet.org',
    chainId: types_1.ChainId.Alfajores,
};
exports.Baklava = {
    name: NetworkNames.Baklava,
    rpcUrl: 'https://baklava-forno.celo-testnet.org',
    graphQl: 'https://baklava-blockscout.celo-testnet.org/graphiql',
    explorer: 'https://baklava-blockscout.celo-testnet.org',
    chainId: types_1.ChainId.Baklava,
};
exports.Mainnet = {
    name: NetworkNames.Mainnet,
    rpcUrl: 'https://forno.celo.org',
    graphQl: 'https://explorer.celo.org/graphiql',
    explorer: 'https://explorer.celo.org',
    chainId: types_1.ChainId.Mainnet,
};
var WalletTypes;
(function (WalletTypes) {
    WalletTypes["Valora"] = "Valora";
    WalletTypes["MetaMask"] = "MetaMask";
    WalletTypes["WalletConnect"] = "WalletConnect";
    WalletTypes["CeloWallet"] = "CeloWallet";
    WalletTypes["CeloTerminal"] = "CeloTerminal";
    WalletTypes["CeloExtensionWallet"] = "CeloExtensionWallet";
    WalletTypes["Ledger"] = "Ledger";
    WalletTypes["Injected"] = "Injected";
    WalletTypes["PrivateKey"] = "PrivateKey";
    WalletTypes["Unauthenticated"] = "Unauthenticated";
})(WalletTypes = exports.WalletTypes || (exports.WalletTypes = {}));
/**
 * Gets the provider associated with a wallet type.
 * @param wallet
 * @returns
 */
var getProviderForWallet = function (wallet) {
    return wallet === WalletTypes.Unauthenticated ? null : SupportedProviders[wallet];
};
exports.getProviderForWallet = getProviderForWallet;
/**
 * Default networks to connect to.
 */
exports.DEFAULT_NETWORKS = [exports.Mainnet, exports.Alfajores];
//# sourceMappingURL=constants.js.map